import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function DoorlyProVerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('No verification token found in the URL.');
      return;
    }
    axios
      .post(`${API_URL}/api/doorlypro/verify-email`, { token })
      .then((res) => { setStatus('success'); setSuccessMsg(res.data?.message || ''); })
      .catch((err) => {
        setStatus('error');
        setErrorMsg(err.response?.data?.error || 'Verification failed. The link may have expired.');
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        {status === 'loading' && (
          <>
            <div
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5"
              style={{ backgroundColor: '#eff3fe' }}
            >
              <svg className="animate-spin" width="28" height="28" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#3a6ad9" strokeWidth="4" />
                <path className="opacity-75" fill="#3a6ad9" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Verifying your email...</h2>
            <p className="text-gray-500 text-sm">Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5"
              style={{ backgroundColor: '#f0fde4' }}
            >
              <svg width="28" height="28" fill="none" stroke="#acf44e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Email Verified!</h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              {successMsg || 'Your email address has been verified. You can now sign in to your DoorlyPro account.'}
            </p>
            <Link
              to="/doorlypro/login"
              className="btn-primary text-white hover:opacity-90"
              style={{ backgroundColor: '#3a6ad9', display: 'inline-flex' }}
            >
              <span>Sign In to DoorlyPro</span>
              <span className="btn-arrow">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5l7 7-7 7"/></svg>
              </span>
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5"
              style={{ backgroundColor: '#fff0f3' }}
            >
              <svg width="28" height="28" fill="none" stroke="#ff082f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Verification Failed</h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">{errorMsg}</p>
            <Link to="/doorlypro/login" className="font-semibold text-sm" style={{ color: '#3a6ad9' }}>
              Back to Sign In
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
